// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv #viewModal footer {\r\n  display: none !important;\n}\n[dir] .input-group:not(.bootstrap-touchspin):focus-within {\r\n  box-shadow: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
